import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const UserDashboard = lazyLoader(
  () => import("Containers/User/UserDashboard/UserDashboard")
);

export const ContactsDashboardPage = () => {
  return (
    <Layout>
      <UserDashboard type="contact" />
    </Layout>
  );
};
